import { useI18n } from '@change-corgi/core/react/i18n';

import { useMembershipModalState } from '../../../../modalContext';
import { useLocalizedHeadline } from '../useLocalizedHeadline';

type Result = {
	headline: string;
	description: string;
	isSunriseEnabled: boolean;
};

export function useHeader(): Result {
	const [{ useDonationLanguage, isSunriseEnabled }] = useMembershipModalState();
	const { translate } = useI18n();

	const localizedHeadline = useLocalizedHeadline();

	const getSuffix = () => {
		return useDonationLanguage ? '_donation' : '';
	};

	return {
		headline: localizedHeadline,
		description: translate(`corgi.co.ppmu.modal.description${getSuffix()}`),
		isSunriseEnabled,
	};
}
